var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "column justify-center items-center q-mb-md",
        attrs: { id: "printable" }
      },
      [
        _c("qrcode", {
          attrs: { value: _vm.getUrl, options: { width: 300 }, tag: "img" }
        }),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("code")) +
              ": " +
              _vm._s(_vm.qrcode_formated_code) +
              "  "
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm justify-center" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "events" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("print"),
              icon: "far fa-print"
            },
            on: {
              click: function($event) {
                return _vm.print()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }